// Copyright 2022 Merit International Inc. All Rights Reserved.
// migrated from merit-frontend/src/util/getAuthState.ts

// TODO (PE-48): add polyfill for RN envs using import "react-native-get-random-values";
import { v4 as uuidv4 } from "uuid";

export type AuthStateKey = string;

export const generateAuthState = (): AuthStateKey => uuidv4();
